// extracted by mini-css-extract-plugin
module.exports = {"signUpImage":"styles__signUpImage--1NPNc","modalBody":"styles__modalBody--3VZF5"};